const NS2S = 1.0 / 1000000000.0;
const NS2MS = 1.0 / 1000000.0;
const NS2MS_Fac = 1000000;

export class PerformanceItem {
  className? = "";
  name: string;

  autoReset?: boolean;
  debugValue?: any;

  nsStart: DOMHighResTimeStamp = 0.0;
  counter: number = 0;
  totalMS: number = 0.0;
  maxMS: number = 0.0;
  minMS: number = 1e10;

  constructor(
    param:
      | string
      | {
          name: string;
          autoReset?: boolean;
          className?: string;
        },
  ) {
    if (typeof param === "string") {
      this.name = param;
    } else {
      this.autoReset = param.autoReset;
      this.className = param.className;
      this.name = param.name;
    }

    EstadaPerformance.addItem(this);
  }

  get fullname(): string {
    if (this.className) {
      return `${this.className}.${this.name}`;
    } else {
      return this.name;
    }
  }

  reset() {
    this.counter = 0;
    this.totalMS = 0.0;
    this.maxMS = 0;
    this.minMS = 0;
  }

  addNS(l: number) {
    this.addMS(l / NS2MS_Fac);
  }

  addMS(ms: number) {
    this.counter++;
    this.totalMS += ms;
  }

  // digitFactor = 10 --> eine Nachkommastelle
  averageMS(digitFactor: number = 1.0): number {
    if (this.counter == 0) {
      return 0.0;
    } else {
      return Math.round((this.totalMS / this.counter) * digitFactor) / digitFactor;
    }
  }

  runsPerSecond(): number {
    if (this.counter == 0) {
      return -9.0;
    }
    const a = this.averageMS();
    return Math.floor((1000 / a) * 10.0) / 10.0;
  }

  start() {
    this.nsStart = performance.now();
  }

  stop(): number {
    const nsStop = performance.now();
    const delta = nsStop - this.nsStart;
    this.addMS(delta);
    this.maxMS = Math.max(this.maxMS, delta);
    this.minMS = Math.min(this.minMS, delta);
    return delta;
  }

  run(f: () => any) {
    this.start();
    const res = f();
    this.stop();
    return res;
  }

  async runAsync(f: () => Promise<any>) {
    this.start();
    const res = await f();
    this.stop();
    return res;
  }
}

export function EP(name: string): PerformanceItem {
  let item = EstadaPerformance.items.get(name);
  if (!item) {
    item = new PerformanceItem(name);
  }
  return item;
}

export class EstadaPerformance {
  static items = new Map<string, PerformanceItem>();

  static addItem(item: PerformanceItem) {
    if (!EstadaPerformance.items.has(item.name)) {
      EstadaPerformance.items.set(item.name, item);
    }
  }

  static resetAllAutoResetItems() {
    EstadaPerformance.items.forEach((item) => {
      if (item.autoReset) {
        item.reset();
      }
    });
  }

  static itemsSortByName(): Array<PerformanceItem> {
    const arr = Array.from(EstadaPerformance.items.values());
    arr.sort((a, b) => {
      return a.fullname.localeCompare(b.fullname);
    });
    return arr;
  }
}
